module.exports = __webpack_public_path__ + "img/act-now-icon.29d71bc3.jpg";